/**
 * Pure helpers for filing UI (status normalization, group selectors).
 * Visibility / actor rules live in `filingDefinitionHelpers` + `useWorkflowFilingSection`.
 */

/** DynamicForm / config section id for filing fields */
export const FILING_SECTION_ID = 'fileTypeFileName';

/**
 * @param {string|undefined|null} status
 * @returns {string} Uppercase status token; empty/undefined → DRAFT
 */
export function normalizeWorkflowStatus(status) {
  if (status == null || String(status).trim() === '') return 'DRAFT';
  return String(status).trim().toUpperCase();
}

/**
 * Workflow is at the filing step (assignee completes filing / folder selection).
 */
export function isFilingStatus(workflowStatus) {
  return normalizeWorkflowStatus(workflowStatus) === 'FILING';
}

/**
 * Group / sub-group dropdowns: visible during FILING, or when a category was already saved.
 * @param {string|undefined|null} workflowStatus
 * @param {{ groupCategory?: string, group_category?: string }} [filingValues]
 */
export function shouldShowFilingGroupSelectors(workflowStatus, filingValues = {}) {
  const gc = filingValues?.groupCategory ?? filingValues?.group_category;
  return isFilingStatus(workflowStatus) || Boolean(gc);
}
